module.exports = __webpack_public_path__ + "static/User-Satisfaction-058650b007f14c526c6c9b0f889675c9.svg";